import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Inscription } from '@common-fe/common-fe';

interface TriggerNotificationProps {
  isSendTriggerNotification?: boolean;
}

export const TriggerNotification: React.FC<TriggerNotificationProps> = ({
  isSendTriggerNotification,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      pad={{ vertical: 'm', horizontal: '20px' }}
      round="container2Round"
      background="canvas"
      border={{ color: 'border2', size: '1px' }}
      height="52px"
    >
      <Inscription color="textBody" lineHeight="20px">{isSendTriggerNotification ? t('Send notifications') : 'N/A'}</Inscription>
    </Box>
  );
};
